import { getOfficialStandardText } from "../../data/defensieStandards";

const korpsCommandoTroepenConfig = {
  meta: {
    title: "Voorbereiding Korps Commandotroepen | Mission Movement",
    description:
      "Alles over voorbereiding richting het Korps Commandotroepen: KCT selectie, ECO, fysieke eisen, mentale weerbaarheid, belastbaarheid en gerichte training via Mission Movement.",
    ogTitle: "Voorbereiding Korps Commandotroepen | Mission Movement",
    ogDescription:
      "Alles over voorbereiding richting het Korps Commandotroepen: KCT selectie, ECO, fysieke eisen, mentale weerbaarheid, belastbaarheid en gerichte training via Mission Movement.",
    ogImage: "https://missionmovement.nl/img/thestory.png",
    ogUrl: "https://missionmovement.nl/units/commandotroepen",
    canonical: "https://missionmovement.nl/units/commandotroepen",
  },
  hero: {
    eyebrow: "Korps Commandotroepen",
    imageSrc: "/img/eenheden/kct.webp",
    imageAlt: "KCT trainingsvisual",
    objectPosition: "center 20%",
    overlayClass: "mm-heroOverlay",
    title: "Korps Commandotroepen",
    subtitle:
      "Voor kandidaten die serieus richting het Korps Commandotroepen willen werken: van fysieke basis en mentale weerbaarheid tot selectie, ECO en belastbaarheid.",
  },
  subNav: {
    variant: "dark",
    scrollable: false,
  },
  intro: {
    emblemSrc: "/img/eenheden/kct-embleem.svg",
    emblemAlt: "KCT Embleem",
    heading: "Wat is het KCT?",
    body:
      "Het Korps Commandotroepen (KCT) is de Special Operations Force van de Koninklijke Landmacht. De eenheid voert wereldwijd specialistische operaties uit, vaak onder strikte geheimhouding en in hoog-risico-gebieden. Commandotroepen worden ingezet voor verkenningen, sabotage, precisieacties en het ondersteunen van buitenlandse eenheden in vijandig gebied.\n\nToelating tot het KCT is een van de zwaarste trajecten binnen Defensie. Kandidaten worden geselecteerd op fysieke kracht, mentale weerbaarheid, uithoudingsvermogen en het vermogen om zelfstandig te opereren onder druk. Alleen wie alle fasen van de selectie en opleiding doorstaat, mag zich uiteindelijk commando noemen.\n\nVoor kandidaten betekent dit dat voorbereiding verder moet gaan dan alleen hard trainen. Je moet bouwen aan kracht, uithoudingsvermogen, herstel, navigatiebasis, mentale weerbaarheid en het vermogen om onder druk te blijven functioneren. Niet alleen om aan de start te verschijnen, maar om met meer marge aan het traject te beginnen.",
    accentBorder: "border-mmAccent",
  },
  accordion: {
    heading: null,
    items: [
      {
        title: "Ontstaan & Missie",
        image: "/img/korpscommandotroepen/eerstecommandos.jpg",
        objectPosition: "top",
        content:
          "Het Korps Commandotroepen (KCT) is de Special Forces-eenheid van de Koninklijke Landmacht. Opgericht in 1942 en geïnspireerd door de Britse commando's, heeft het KCT zich ontwikkeld tot een elite-eenheid gespecialiseerd in operaties onder de zwaarste omstandigheden. Het motto 'Nunc aut Nunquam' (Nu of nooit) weerspiegelt de altijd-paraate en doortastende aard van het korps. Het KCT is wereldwijd inzetbaar voor specialistische operaties, vaak in het diepste geheim.",
      },
      {
        title: "Inzet & Specialisaties",
        image: "/img/korpscommandotroepen/inzet.jpg",
        objectPosition: "center",
        content:
          "Het KCT voert drie hoofdtaken uit binnen het domein van Speciale Operaties:\n\n- **Direct Action (DA):** snelle, kleinschalige gevechtsoperaties in vijandig gebied zoals uitschakelen, ontvoeren of bevrijden.\n- **Special Reconnaissance (SR):** inlichtingen verzamelen diep in vijandelijk gebied, vaak zonder ontdekt te worden.\n- **Military Assistance (MA):** het opleiden en begeleiden van (buitenlandse) partnereenheden, eventueel tot in actie.\n\nOperators kunnen zich verder specialiseren als Sniper, JTAC, Medic, Mountain Leader of Combat Diver. Elke ploeg heeft daarnaast specialisten voor bergachtig terrein, onderwaterinzet of parachutesprongen van grote hoogte.",
      },
      {
        title: "Structuur & Locaties",
        image: "/img/korpscommandotroepen/structuur.jpg",
        objectPosition: "object-top",
        content:
          "Het KCT is gevestigd op de Engelbrecht van Nassaukazerne in Roosendaal. De eenheid bestaat uit operationele squadrons, Commandotroepencompagnieën (Cotrcie), en ondersteunende afdelingen. Operators werken in kleine teams die volledig zelfstandig moeten kunnen opereren onder extreme omstandigheden. Vertrouwelijkheid, precisie en flexibiliteit zijn kernwaarden binnen deze organisatie.",
      },
      {
        title: "Keuring & Selectiemomenten",
        image: "/img/korpscommandotroepen/eco_02.jpg",
        objectPosition: "top",
        content:
          "De fysieke basiseisen voor de KCT-informatiedagen zijn één onderdeel van de voorbereiding op het sollicitatietraject. De functiegebonden aanstellingskeuring en latere selectie- en opleidingsfasen zijn afzonderlijke beoordelingen. Gebruik de officiële KCT-pagina, je vacature en uitnodiging voor de actuele instroomroute en testprotocollen.",

      },
      {
        title: "Fysieke basiseisen KCT-informatiedagen",
        image: "/img/korpscommandotroepen/fysiek.jpg",
        objectPosition: "bottom",
        content: getOfficialStandardText("kct"),

      },
      {
        title: "Carrièrepad & Special Forces",
        image: "/img/korpscommandotroepen/specialforces.jpg",
        objectPosition: "center",
        content:
          "Vervolgopleiding en specialisatie vragen meer dan het halen van een fysieke basistest. Als algemene context kun je denken aan verkenning, communicatie, medische ondersteuning en bewegen in verschillende terreinen. Dit zijn voorbeelden van militaire vaardigheidsgebieden, geen actuele lijst met selectieopdrachten of een vaste specialisatieroute. Raadpleeg Defensie voor het opleidingsverloop dat bij jouw instroom hoort.",
      },
      {
        title: "Voorbereiding & Realiteit",
        image: "/img/korpscommandotroepen/kctuitval.jpg",
        objectPosition: "center",
        content:
          "Een trainingsscore voorspelt niet of je een selectie of opleiding afrondt. Voor je voorbereiding kun je werken aan kracht, duurvermogen, herstel, bewegen met belasting en oriëntatievaardigheden. Hindernissen en navigatie zijn hier trainingscontext, geen extra eisen voor de KCT-informatiedagen. Gebruik voor officiële opdrachten en eventuele tijdslimieten alleen de informatie bij het betreffende testmoment.",
      },
      {
        title: "Voortgezette Commando Opleiding (VCO)",
        image: "/img/korpscommandotroepen/vco.jpg",
        objectPosition: "center",
        content:
          "De voortgezette commandoopleiding hoort bij de opleidingsroute en is geen extra onderdeel van de fysieke basiseisen voor informatiedagen. Voorbereiding kan aandacht geven aan belastbaarheid, herstel, samenwerken en omgaan met wisselende omstandigheden. Gebruik de officiële KCT-informatie voor de actuele duur, inhoud en volgorde van opleidingsonderdelen.",
      },
    ],
  },
  contentBlocks: [
    {
      heading: "Specialisaties binnen het KCT",
      items: [
        {
          title: "Speciale Inzetmethodes",
          content:
            "Binnen het KCT zijn er drie operationele inzetvormen waaraan commando’s zich kunnen specialiseren:\n\n- Air (vrije val): Operaties op grote hoogte met parachutesprongen (HALO/HAHO). Operators springen ongezien vanuit vliegtuigen tot op 10 km hoogte met zuurstofmaskers en zware bepakking.\n\n- Mountain (OBT): Opereren in extreem bergachtig terrein. Commando’s leren klimmen, abseilen, overleven en tactisch optreden in sneeuw, rotsen en op grote hoogte.\n\n- Water (combat diver): Infiltreren via rivieren, meren of havens. Zij zijn getraind in gesloten duiksystemen, gevechtszwemmen en onopvallend verplaatsen onder water.",
        },
        {
          title: "Individuele Specialisaties",
          content:
            "Elke commandoploeg beschikt over specialisten met unieke functies. Na de voortgezette opleiding kunnen operators geselecteerd worden voor:\n\n- Sniper: Precisie-optreden op afstanden tot 2 km. Getraind in observatie, camouflage en stealth-operaties.\n- Demspec (Demolition Specialist): Werkt met springstoffen en voert precisie-sabotage uit.\n- Comspec (Communicatiespecialist): Zorgt voor veilige en langeafstand communicatie onder alle omstandigheden.\n- Medic: Verleent geavanceerde medische hulp op het slagveld, tot 72 uur zelfstandig opereren met gewonden.\n\nDeze opleidingen zijn fysiek en cognitief zeer zwaar en enkel voorbehouden aan operators die zich langdurig bewezen hebben.",
        },
      ],
    },
  ],
  cta: {
    eyebrow: "KCT voorbereiding",
    heading: "Wil je serieus richting het Korps Commandotroepen?",
    body:
      "Iedere richting vraagt een andere combinatie van kracht, conditie, belastbaarheid, herstel en mentale weerbaarheid. Daarom werk je binnen Mission Movement vanuit een vaste 12-weekse structuur, met accenten die passen bij jouw doel. Je traint niet alleen voor de test. Je bouwt aan het lichaam dat de opleiding en het werk daarna moet kunnen dragen.",
    buttonText: "Bekijk het 12-weekse programma",
    buttonTo: "/program",
  },
  forWho: {
    heading: "Voor wie is dit geschikt?",
    bullets: [
      "Je wilt commando worden en zoekt structuur in je voorbereiding richting KCT-selectie.",
      "Je traint al, maar weet niet zeker of je voorbereiding aansluit op de keuring, aanvullende tests en opleiding van jouw instroomroute.",
      "Je wilt sterker worden in kracht, uithoudingsvermogen, herstelvermogen en mentale weerbaarheid.",
      "Je wilt niet alleen de minimale norm halen, maar met meer marge aan je traject beginnen.",
      "Je zoekt een duidelijke opbouw waarin elke training een functie heeft binnen de grotere voorbereiding.",
      "Je wilt serieus werken aan discipline, belastbaarheid, navigatiebasis en functioneren onder druk.",
    ],
  },
  route: {
    heading: "Jouw route naar het Korps Commandotroepen",
    steps: [
      "Oriëntatie: begrijpen wat het KCT vraagt",
      "Start voorbereiding: kracht, conditie, herstel en belastbaarheid opbouwen",
      "Aanmelding en selectieprocedure bij Defensie",
      "Functiegebonden keuring en aanvullende fysieke testmomenten volgens je uitnodiging",
      "Elementaire Commando Opleiding (ECO)",
      "Voortgezette Commando Opleiding en operationele inzetbaarheid",
    ],
  },
  faq: {
    heading: "Veelgestelde Vragen",
    items: [
      {
        title: "Welke fysieke basiseisen gelden voor de KCT-informatiedagen?",
        content: getOfficialStandardText("kct"),
      },
      {
        title: "Hoe zwaar is de ECO écht?",
        content:
          "De Elementaire Commando Opleiding (ECO) is een van de zwaarste onderdelen van de route richting het Korps Commandotroepen. Je krijgt te maken met fysieke uitputting, mentale druk, weinig herstel, discipline en besluitvorming onder stress. Gerichte voorbereiding garandeert geen succes, maar kan wel helpen om met betere fysieke en mentale marges aan KCT selectie en opleiding te beginnen.",
      },
      {
        title: "Kan ik trainen naast school of werk?",
        content:
          "Ja, maar het vraagt planning, consistentie en realistisch omgaan met je totale belasting. De voorbereiding kan rond school of werk worden opgebouwd, zolang je eerlijk kijkt naar herstel, beschikbare tijd en prioriteiten. Het doel vraagt discipline en structurele inzet.",
      },
      {
        title: "Wat als ik nog twijfel of ik geschikt ben?",
        content:
          "Twijfel is normaal. Een serieus voorbereidingstraject helpt je duidelijk krijgen waar je nu staat, waar je zwakke punten zitten en of deze route echt bij je past. Je werkt aan fysieke eisen, mentale weerbaarheid, belastbaarheid en functioneren onder druk voordat je het officiële traject instapt. Bij terugkerende pijn, eerdere zware blessures of twijfel over je belastbaarheid is persoonlijk advies verstandiger dan zelfstandig doortrainen.",
      },
      {
        title: "Is dit alleen voor mannen?",
        content:
          "Nee. De voorbereiding is bedoeld voor iedere serieuze kandidaat die richting Defensie of het Korps Commandotroepen wil werken. De principes blijven hetzelfde: kracht, uithoudingsvermogen, herstel, discipline, mentale weerbaarheid en belastbaarheid. De eisen zijn hoog en vragen om eerlijke, gerichte voorbereiding: consistent trainen, eerlijk schalen en pijnsignalen serieus nemen.",
      },
      {
        title: "Wat maakt deze voorbereiding anders dan zelf trainen?",
        content:
          "Zelf trainen kan een goede basis zijn, maar voorbereiding op KCT selectie en ECO vraagt structuur. Het verschil zit in testmomenten, progressieve opbouw, herstelplanning, mentale druk en begrijpen waarom je traint. Zo verspil je minder energie en werk je gerichter aan belastbaarheid, kracht en uithoudingsvermogen.",
      },
    ],
  },
  stickyMobileCta: {
    enabled: true,
    delayMs: 20000,
    label: "Klaar om gericht te trainen?",
    buttonText: "Bekijk het 12-weekse programma",
    buttonTo: "/program",
  },
};

export default korpsCommandoTroepenConfig;
